let optionsInstance;
export const initI18n = (options) => {
    optionsInstance = options;
};
export const getI18nOptions = () => {
    if (!optionsInstance)
        throw new Error('i18n is not initialized');
    return optionsInstance;
};
export const resetI18n = () => {
    optionsInstance = undefined;
};
//# sourceMappingURL=init.js.map